import { type } from './type.js';

/**
 * @description
 * Checks if value is undefined.
 *
 * @example
 * ``` ts
 * isUndefined(undefined);
 * // => true
 * isUndefined(null);
 * // => false
 * isUndefined({});
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is `undefined`, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-undefined
 */
export const isUndefined = (value?): boolean => {
  return type(value) === 'undefined';
};
